/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

/*============================================================================
  Product Page
==============================================================================*/
class ProductCardComponent extends HTMLElement {
    constructor() {
        super();
        
        this.productId = this.getAttribute('data-product');
        
        this.setupOptions();
        this.addEventListener('productVariantChange', this.selectCallback.bind(this));
        this.dispatchEvent(new CustomEvent('productCardReady'));
    }

    init(options) {    
        var moneyFormat = options.money_format,
        variant = options.variant,
        selector = options.selector;

        // Selectors
        var $addToCart = this.querySelector('.addToCartButton'),
        $productPrice = this.querySelector('.productPrice'),
        $comparePrice = this.querySelector('.comparePrice'),
        $quantityElement = this.querySelector('.quantity-container'),
        $addToCartText = this.querySelector('.addToCartText');

        if (variant) {
        if (variant.featured_media) {
            var productImages = this.querySelector('.productImages');
            productImages.setAttribute('data-featured-img', variant.featured_media.id);

            if (productImages.classList.contains('featured-img-first')) {
            productImages.classList.remove('featured-img-first');
            } else {
            this.querySelector('product-images').setAttribute('data-variant-image', variant.featured_media.id);
            document.dispatchEvent(new CustomEvent('variantSelected', { detail: { imgId: variant.featured_media.id } }));
            }
        }

        if (variant.available) {
            $addToCart.classList.remove('disabled');
            $addToCart.removeAttribute('disabled');
            $addToCartText.innerHTML = universe.addToCartLabel;
            
            $quantityElement.style.display = 'block';
        } else {
            // Sold out, disable the submit button, change text, hide quantity elements
            $addToCart.classList.add('disabled');
            $addToCart.setAttribute('disabled', true);
            $addToCartText.innerHTML = universe.soldOutLabel;
            $quantityElement.style.display = 'none';
        }

        $productPrice.innerHTML = '<span class="money money-variant-update">' + Shopify.formatMoney(variant.price, moneyFormat) + '</span>';
        
        if (variant.compare_at_price > variant.price) {
            $comparePrice.innerHTML = '<span class="money money-variant-update">' + Shopify.formatMoney(variant.compare_at_price, moneyFormat) + '</span>';
            $comparePrice.style.display = 'inline-block';
        } else {
            if ($comparePrice) {
            $comparePrice.style.display = 'none';
            }
        }
        } else {
        $addToCart.classList.add('disabled');
        $addToCart.setAttribute('disabled', true);
        $addToCartText.innerHTML = universe.unavailableLabel;
        $quantityElement.style.display = 'none';
        }
        
        if (variant) {        
            var form = this.querySelector('.product-form-wrap > form');
        for (var i = 0, length = variant.options.length; i < length; i++) {        
            var radioButtons = form.querySelector('.swatch[data-option-index="' + i + '"]');
            if (radioButtons) {
            radioButtons.querySelectorAll('input').forEach(radio => {
                if (radio.getAttribute('value') == variant.options[i]) {              
                radio.checked = true;
                }
            });
            }       
        }
        }        
    }

    selectCallback(evt) {    
        var money_format = evt.detail.money_format,
        selector = evt.detail.selector,
        variant = evt.detail.variant;
    
        this.init({
            money_format: money_format,
            variant: variant,
            selector: selector
        });

        document.body.dispatchEvent(new CustomEvent('productVariantChanged'));
    }

    setupOptions() {
        this.querySelectorAll('.swatch [type="radio"]').forEach(radioEl => {
        radioEl.addEventListener('click', this.onOptionClick.bind(this));
        });
    }

    onOptionClick(evt) {    
        var optionIndex = evt.target.closest('.swatch').getAttribute('data-option-index');    
        var optionValue = evt.target.closest('[type="radio"]').value;  

        var form = evt.target.closest('form');
        form.querySelectorAll('.single-option-selector').forEach((option, index) => {      
        if (index == optionIndex) {
            option.value = optionValue;        
            option.dispatchEvent(new Event('change'));
        }
        });    
    }
}

customElements.define('product-card', ProductCardComponent);

/*============================================================================
  Header
==============================================================================*/
class StickyHeaderComponent extends HTMLElement {
    constructor() {
        super();

        this.headerContainer = this.querySelector('.header-container');
        this.mainContent = document.querySelector('.main-content');
        this.onResize = this.headerHeight.bind(this);    
        this.isExpanded = true;
        
        this.init();
        window.addEventListener('scroll', this.onScroll.bind(this), false);
    }

    init() {
        this.onScroll();
        setTimeout(() => {
        this.headerHeight();    
        }, 50); 
        window.addEventListener('resize', this.onResize);    
    } 

    headerHeight() {
        if (!this.headerContainer.classList.contains('shrink-header')) {      
        this.mainContent.style.paddingTop = this.headerContainer.offsetHeight + "px";      
        }
    }

    onScroll() {    
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop >= 30 && this.isExpanded) {      
        this.shrink();
        }

        if (scrollTop < 30 && !this.isExpanded) {     
        this.reveal();
        }    
    }

    shrink() {
        this.headerContainer.classList.add('shrink-header');
        this.isExpanded = false;
    }

    reveal() {    
        this.headerContainer.classList.remove('shrink-header');
        this.isExpanded = true;
    }
}

customElements.define('sticky-header', StickyHeaderComponent);


class HeaderSearch extends HTMLElement {
    constructor() {
        super();

        this.container = this.querySelector('form');
        this.searchField = this.querySelector('input[type="search"]');

        this.querySelector('.header__search-btn').addEventListener('click', this.show.bind(this));
        this.searchField.addEventListener('focusout', this.hide.bind(this));
    }

    show(evt) {    
        if (!this.container.classList.contains('form-active')) {
        evt.preventDefault();
        this.container.classList.add('form-active');
        this.searchField.focus() ;      
        }    
    }

    hide(evt) {    
        if (!evt.relatedTarget) {
        this.container.classList.remove('form-active');
        } 
    }
}

customElements.define('header-search', HeaderSearch);

/*============================================================================
  Accordion
==============================================================================*/
class AccordionComponent extends HTMLElement {
    constructor() {
        super();

        this.container = this.querySelector('.accordion');
        this.container.role = "tablist";

        this.init();        
    }

    init() {
        this.container.querySelectorAll('.accordion-item > .accordion-title').forEach(accordionItem => {
            accordionItem.addEventListener('click', this.toggle.bind(this));
            accordionItem.setAttribute('aria-expanded', false);
        });
    }

    toggle(e) {
        e.preventDefault();
        var accordionItem = e.target.parentNode;

        if (accordionItem.classList.contains('is-active')) {
            setTimeout(() => { accordionItem.classList.remove('is-active'); }, 250);        
            accordionItem.setAttribute('aria-expanded', false);
            collapseAccordionItem(accordionItem.querySelector('.accordion-content'));
        } else {
            accordionItem.classList.add('is-active');
            accordionItem.setAttribute('aria-expanded', true);
            expandAccordionItem(accordionItem.querySelector('.accordion-content'));
        }        
    }
}

customElements.define('content-accordion', AccordionComponent);


function collapseAccordionItem(element) {    
    var sectionHeight = element.scrollHeight;
    var elementTransition = element.style.transition;
    element.style.transition = '';

    requestAnimationFrame(function() {
        element.style.height = sectionHeight + 'px';
        element.style.transition = elementTransition;
        
        requestAnimationFrame(function() {
        element.style.height = 0 + 'px';
        });
    });
        
    element.setAttribute('data-collapsed', 'true');
}

function expandAccordionItem(element) {
    var sectionHeight = element.scrollHeight;    
    element.style.height = sectionHeight + 'px';  
    element.setAttribute('data-collapsed', 'false');
}


/*============================================================================
  Drawer Component
==============================================================================*/
class DrawerComponent extends HTMLElement {
  constructor() {
      super();

      this.sidebarId = this.getAttribute('data-sidebar') || '';
      this.pageContainer = document.body.querySelector('#PageContainer');
      this.headerContainer = document.body.querySelector('.header-container');
      this.drawerContainer = this.querySelector('.off-canvas');        
      this.toggleBtns = document.body.querySelectorAll('[data-toggle="' + this.sidebarId + '"]');

      this.position = this.getAttribute('drawer-position') == 'left' ? 'right' : 'left';        

      this.isOpen = false;

      this.overlay = this.init();
      this.overlay.addEventListener('click', this.close.bind(this));

      this.toggleBtns.forEach(btn => {            
          btn.addEventListener('click', this.toggle.bind(this));
      });

      document.addEventListener('sidebarOpen', this.onAnySidebarOpen.bind(this));
      document.addEventListener('activateSidebar', this.onActivateSidebar.bind(this));
  }

  onAnySidebarOpen(e) {        
      if (e.detail.sidebarId != this.sidebarId) {
          this.close();
      }
  }

  onActivateSidebar(e) {        
      if (e.detail.sidebarId == this.sidebarId) {
          this.open();
      }
  }

  init() {
      this.drawerContainer.classList.add('is-transition-overlap', 'is-closed');

      var overlay = document.createElement('div');
      overlay.classList.add('js-off-canvas-overlay', 'is-overlay-fixed');
      document.body.appendChild(overlay);

      return overlay;
  }

  toggle() {
      if (this.isOpen) {
          this.close();
      } else {
          this.open();
      }
  }

  open() {        
      if (this.isOpen)
          return;

      this.drawerContainer.classList.remove('is-closed');
      this.drawerContainer.classList.add('is-open');

      this.pageContainer.classList.add('content_pushed-' + this.position);
      this.headerContainer.classList.add('content_pushed-' + this.position);
      this.overlay.classList.add('is-visible', 'is-closable');
      this.isOpen = true;

      this.triggerEvent();
  }

  close() {
      if (!this.isOpen)
          return;
      
      this.drawerContainer.classList.remove('is-open');
      this.drawerContainer.classList.add('is-closed');

      this.pageContainer.classList.remove('content_pushed-' + this.position);
      this.headerContainer.classList.remove('content_pushed-' + this.position);
      this.overlay.classList.remove('is-visible', 'is-closable');
      this.isOpen = false;
  }

  triggerEvent() {    
      var event = new CustomEvent("sidebarOpen", {
          detail: {
              sidebarId: this.sidebarId
          }
      });
      document.dispatchEvent(event);
  }
}

customElements.define('drawer-sidebar', DrawerComponent);


/*============================================================================
  Dropdown Menu
==============================================================================*/
class DropdownComponent extends HTMLElement {
  constructor() {
      super();

      this.container = this.querySelector('.menu');
      this.container.role = "menu";

      this.init();
  }

  init() {
      this.container.querySelectorAll('.menu-item_parent').forEach(parentMenuItem => {
          parentMenuItem.classList.add('is-dropdown-submenu-parent');
          parentMenuItem.classList.add('opens-right');
          parentMenuItem.role = "menuitem";        
      });

      this.container.querySelectorAll('.sub-menu').forEach(subMenu => {            
          subMenu.role = "menu";
          subMenu.classList.add('is-dropdown-submenu', 'opens-right');
      });
  }
}

customElements.define('dropdown-menu', DropdownComponent);


/*============================================================================
  Google Maps
==============================================================================*/
class GoogleMapsComponent extends HTMLElement {
    constructor() {
        super();

        this.container = this.querySelector('.map__container');        
        this.map = null;
        this.location = null;

        document.addEventListener('googleMapsApiLoaded', this.geolocate.bind(this));
        this.addEventListener('googleMapsGeocoded', this.newMap.bind(this));        
    }

    connectedCallback() {
        this.init();
    }

    init() {
        var api_key = this.container.getAttribute('data-api-key');
        if(api_key.length && this.container) {
            if (!universe.maps_api_ready) {             
                var script = document.createElement('script');
                script.onload = function () {                  
                    universe.maps_api_ready = 1;
                    
                    var event = new CustomEvent('googleMapsApiLoaded');
                    document.dispatchEvent(event);
                };
                script.src = 'https://maps.googleapis.com/maps/api/js?key=' + api_key;

                document.head.appendChild(script); 
            } else {
                this.geolocate();
            }
        } 
    }

    geolocate () {
        var geocoder = new google.maps.Geocoder();
        var address = this.container.getAttribute('data-address-setting');
        var $this = this;
        
        geocoder.geocode({ address: address }, function(results, status) {
            if (status !== google.maps.GeocoderStatus.OK)
                return false;
            
            var event = new CustomEvent('googleMapsGeocoded', {
                detail: { location: results[0].geometry.location }
            });
            $this.dispatchEvent(event);
        });
    }

    newMap(e) {
        this.location = e.detail.location;

        var map = new google.maps.Map(this.container, {
            zoom: 14,
            disableDefaultUI: true,
            center: this.location,
            scrollwheel: false,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_CENTER
            }
        });
        var marker = new google.maps.Marker({
            position: this.location,
            map: map
        });
        
        if(window.innerWidth > 1024) {
            map.panBy(270, 0);
        }
        
        this.map = map;
        window.addEventListener('resize', this.onResize.bind(this));
    }

    onResize() {
        if (this.map != null) {
            if(window.innerWidth > 1024) {
                this.map.setCenter(this.location);
                this.map.panBy(270, 0);                
            } else {
                this.map.setCenter(this.location);                
            }   
        }
    }
}

customElements.define('google-maps', GoogleMapsComponent);

/*============================================================================
  Mega Menu
==============================================================================*/
class MegaMenuComponent extends HTMLElement {
    constructor() {
        super();

        this.container = this.querySelector('.primary-mega-menu');
        this.container.role = "menu";
        
        this.addEventListener('showMegaMenu', this.onMegaMenuShow.bind(this))
    }

    connectedCallback() {
        this.init();
    }

    onMegaMenuShow(e) {
        document.body.querySelectorAll('.universe-mega-menu').forEach(megaMenuItem => {
            if (e.detail.megaMenuId != megaMenuItem.id) {
                megaMenuItem.classList.remove('is-open', 'is-active');                
            }       
        });             
    }

    init() {
        this.container.querySelectorAll('.mega-menu__parent-item').forEach(parentMenuItem => {
            parentMenuItem.addEventListener('mouseenter', this.showMenu.bind(this));
            parentMenuItem.addEventListener('mouseleave', this.onMouseLeave.bind(this));
        });
    }

    showMenu(e) {    
        e.target.classList.add('hover');
        const megaMenuId = e.target.getAttribute('data-toggle');        
        var megaMenuItem = document.body.querySelector('#' + megaMenuId);

        megaMenuItem.classList.add('is-open');
        megaMenuItem.addEventListener('mouseenter', this.activateMegaMenu.bind(this));
        megaMenuItem.addEventListener('mouseleave', this.deactivateMegaMenu.bind(this));

        var event = new CustomEvent('showMegaMenu', {
            detail: { megaMenuId: megaMenuId }
        });
        this.dispatchEvent(event);
    }

    activateMegaMenu(e) {        
        e.target.classList.add('is-active', 'is-open');
    }

    deactivateMegaMenu(e) {
        if (e.target.classList.contains('is-active')) {
            e.target.classList.remove('is-active');
        }
    
        setTimeout(() => {            
            if (!this.container.querySelector('.mega-menu__parent-item[data-toggle="' + e.target.id + '"]').classList.contains('hover')) {
                e.target.classList.remove('is-open');
            }
        }, 200);
    }

    onMouseLeave(e) {
        e.target.classList.remove('hover');
        const megaMenuId = e.target.getAttribute('data-toggle');
        var megaMenuItem = document.body.querySelector('#' + megaMenuId);

        setTimeout(() => {
            if (!megaMenuItem.classList.contains('is-active')) {
                megaMenuItem.classList.remove('is-open');
            }
        }, 200);
    }
}

customElements.define('mega-menu', MegaMenuComponent);

/*============================================================================
  Mobile Menu
==============================================================================*/
class MobileMenuComponent extends HTMLElement {
    constructor() {
        super();

        this.container = this.querySelector('.mobile-menu');         
        this.init();
    }

    init() {
        this.container.querySelectorAll('.mobile-menu__item--parent').forEach(parentMenuItem => {
            parentMenuItem.classList.add('is-accordion-submenu-parent', 'has-submenu-toggle');
            var arrow = document.createElement('button');
            arrow.setAttribute('aria-expanded', false);
            arrow.innerHTML = "<span class='submenu-toggle-text'>Open Menu</span>"
            arrow.classList.add('submenu-toggle');
            parentMenuItem.appendChild(arrow);            

            arrow.addEventListener('click', this.toggleSubmenu.bind(this));
        });

        this.container.querySelectorAll('.mobile-menu__item--parent .mobile-menu__item').forEach(parentMenuItem => {
            parentMenuItem.classList.add('is-accordion-submenu-item');
        });

        this.container.querySelectorAll('.mobile-submenu').forEach(subMenu => {                        
            subMenu.classList.add('submenu', 'is-accordion-submenu');
            subMenu.style.display = 'none';
        });
    }

    toggleSubmenu(e) {        
        var submenu = e.target.parentNode.querySelector('.mobile-submenu');

        if (submenu.classList.contains('is-active')) {            
            submenu.classList.remove('is-active');
            submenu.style.display = 'none';
            e.target.setAttribute('aria-expanded', false);
        } else {            
            submenu.classList.add('is-active');
            submenu.style.display = 'block';
            e.target.setAttribute('aria-expanded', true);
        }      
    }
}

customElements.define('mobile-menu', MobileMenuComponent);

/*============================================================================
  Carousel
==============================================================================*/
class CarouselComponent extends HTMLElement {
    constructor() {
        super();        
        this.controls = null;
        this.defaultOffset = 15;

        var mainSelector = this.getAttribute('main'),
            trackSelector = this.getAttribute('track'),
            wrapperSelector = this.getAttribute('wrapper'),
            elementSelector = this.getAttribute('element');
        
        this.wrapper = this.querySelector(wrapperSelector);
        this.carouselTrack = this.querySelector(trackSelector);
        this.querySelector(mainSelector).classList.add('carousel');
        this.wrapper.classList.add('carousel__inner');
        this.carouselTrack.classList.add('carousel__track');
        
        this.carouselElements = this.querySelectorAll(trackSelector + ' ' + elementSelector);
        this.carouselElements.forEach((item, index) => {
            item.classList.add('carousel__item');
            item.setAttribute('data-item', index);
        });

        this.settings = {            
            mobile: this.getAttribute('mobile') || true,
            desktop: this.getAttribute('desktop') || true,
            columns: parseInt(this.getAttribute('columns')) || 4,
            infinite: this.getAttribute('infinite') || false
        };


        if (window.innerWidth < 750) {
            this.settings.columns = 1;
            this.defaultOffset = 30;
        }        

        this.currentOffset = this.defaultOffset;
        this.itemWidth = this.wrapper.offsetWidth / this.settings.columns;

        if (window.innerWidth < 750) {                        
            this.itemWidth -= 40;            
        }
        
        this.init();
        
        this.touchStartPositionX = 0;
        this.touchStartPositionY = 0;
        this.lastScrollOffsetY = 0;
        this.swipeStarted = false;
        this.swipeInProgress = false;
        this.swipePrevented = false;
        
        window.addEventListener('resize', this.reInit.bind(this));

        if (document.querySelector('.related-products')) {
            document.addEventListener('relatedProductsLoaded', this.reInit.bind(this));
        }        
    }
    
    connectedCallback() {      
        this.reInit();
    }

    init() {        
        this.carouselTrack.style.width = this.itemWidth * this.carouselElements.length + 'px';
        this.carouselTrack.style.transform = 'translate3d(' + this.defaultOffset + 'px, 0px, 0px)';

        this.carouselElements.forEach((item, index) => {
            if (index == 0) {
                item.classList.add('carousel__item--active');
            }
            item.style.width = this.itemWidth + 'px';
        });
        
        if (this.carouselElements.length > this.settings.columns) {
            this.setupControls();
            this.enableSwipes();
        }        
    }

    reInit() {        
        if (window.innerWidth < 750) {
            this.settings.columns = 1;
            this.defaultOffset = 30;
        } else {
            this.settings.columns = parseInt(this.getAttribute('columns')) || 4;
            this.defaultOffset = 15;
        }

        this.currentOffset = this.defaultOffset;
        this.itemWidth = this.wrapper.offsetWidth / this.settings.columns;

        if (window.innerWidth < 750) {
            this.itemWidth -= 40;
        }

        if(this.querySelector('.carousel__item--active'))
            this.querySelector('.carousel__item--active').classList.remove('carousel__item--active');
        
        this.carouselTrack.style.width = this.itemWidth * this.carouselElements.length + 'px';
        this.carouselTrack.style.transform = 'translate3d(' + this.defaultOffset + 'px, 0px, 0px)';

        this.carouselElements.forEach((item, index) => {
            if (index == 0) {
                item.classList.add('carousel__item--active');
            }
            item.style.width = this.itemWidth + 'px';
        });        
    }

    enableSwipes() {                
        this.wrapper.addEventListener("touchstart", this.touchStart.bind(this), { passive: true });
        this.wrapper.addEventListener("touchend",  this.touchEnd.bind(this), { passive: true });
        this.wrapper.addEventListener("touchcancel",  this.touchEnd.bind(this), { passive: true });
        this.wrapper.addEventListener("touchmove",  this.swipe.bind(this), { passive: false });
    }

    setupControls() {
        var prevBtn = document.createElement('button'),
            nextBtn = document.createElement('button');
        
        prevBtn.innerHTML = "Previous";
        prevBtn.classList.add('carousel__prev-btn');

        nextBtn.innerHTML = "Next";
        nextBtn.classList.add('carousel__next-btn');
        
        this.wrapper.parentNode.appendChild(prevBtn);
        this.wrapper.parentNode.appendChild(nextBtn);

        prevBtn.addEventListener('click', this.prevBtnClick.bind(this));
        nextBtn.addEventListener('click', this.nextBtnClick.bind(this));

        this.controls = {
            prevBtn: prevBtn,
            nextBtn: nextBtn
        }

        this.checkControls(0);
    }

    prevBtnClick(evt) {
        var currentItemIndex = parseInt(this.querySelector('.carousel__item--active').getAttribute('data-item'));
        var prevItemIndex = currentItemIndex - 1;

        if (prevItemIndex >= 0) {
            this.activateItem(prevItemIndex);
        } else {
            this.activateItem(currentItemIndex);
        }
    }

    nextBtnClick(evt) {
        var currentItemIndex = parseInt(this.querySelector('.carousel__item--active').getAttribute('data-item'))
        var newItemIndex = currentItemIndex + 1;

        if ((newItemIndex + this.settings.columns) <= this.carouselElements.length) {            
            this.activateItem(newItemIndex);
        } else {
            this.activateItem(currentItemIndex);
        }
    }

    activateItem(newItemIndex) {        
        this.querySelector('.carousel__item--active').classList.remove('carousel__item--active');
        this.querySelector('.carousel__item[data-item="' + newItemIndex + '"]').classList.add('carousel__item--active');

        var newOffset = -newItemIndex * this.itemWidth + this.defaultOffset;

        this.currentOffset = newOffset;
        this.carouselTrack.style.transform = 'translate3d(' + newOffset + 'px, 0px, 0px)';
        this.checkControls(newItemIndex);

        this.dispatchEvent(new CustomEvent('carouselItemActivated', { detail: { itemIndex: newItemIndex }}));
    }

    checkControls(itemIndex) {
        var showPrevBtn = itemIndex > 0;
        var showNextBtn = (parseInt(itemIndex) + this.settings.columns) < this.carouselElements.length;

        this.controls.prevBtn.style.display = showPrevBtn ? 'block' : 'none';
        this.controls.nextBtn.style.display = showNextBtn ? 'block' : 'none';
    }

    touchStart(evt) {        
        if (this.swipeInProgress)
            return;
        
        this.carouselTrack.style.transition = '';

        this.swipeInProgress = true;
        this.swipePrevented = false;
        this.touchStartPositionX = evt.changedTouches[0].screenX;
        this.touchStartPositionY = evt.changedTouches[0].screenY;
        this.lastScrollOffsetY = 0;
    }

    touchEnd(evt) {
        this.swipeStarted = false;

        if (!this.swipeInProgress)
            return;
        
        this.carouselTrack.style.transition = 'transform 0.25s ease';
        this.swipeInProgress = false;

        if (this.swipePrevented)
            return;

        var touchEndX = evt.changedTouches[0].screenX;
        var delta = Math.abs(this.touchStartPositionX - touchEndX);

        if (delta > 50) {
            if (touchEndX > this.touchStartPositionX) {
                this.prevBtnClick();
            }
        
            if (touchEndX < this.touchStartPositionX) {
                this.nextBtnClick();
            }
        } else {            
            this.carouselTrack.style.transform = 'translate3d(' + this.currentOffset + 'px, 0px, 0px)';           
        }
    }

    swipe(evt) {        
        if (!this.swipeInProgress)
            return;
        
        evt.preventDefault();        
        
        if (!this.swipeStarted) {
            if (Math.abs(this.touchStartPositionX - evt.changedTouches[0].screenX) < Math.abs(this.touchStartPositionY - evt.changedTouches[0].screenY)) {
                this.swipePrevented = true;
            }
        }
            
        this.swipeStarted = true;        

        if (!this.swipePrevented) {
            var delta = Math.round(this.touchStartPositionX - evt.changedTouches[0].screenX);
            this.carouselTrack.style.transform = 'translate3d(' + parseInt(this.currentOffset - delta) + 'px, 0px, 0px)';
        } else {
            var deltaY = Math.round(this.touchStartPositionY - evt.changedTouches[0].screenY);            
            window.scrollBy(0, deltaY - this.lastScrollOffsetY);
            this.lastScrollOffsetY = deltaY;
        }
    }
}

customElements.define('products-carousel', CarouselComponent);


class ProductImagesComponent extends CarouselComponent {
    constructor() {
        super();        
        if (window.innerWidth >= 1024) {
            this.defaultOffset = 0;
            this.currentOffset = this.defaultOffset;
            this.carouselTrack.style.transform = 'translate3d(0px, 0px, 0px)';
        }

        this.thumbnails = this.querySelectorAll('.productImagesNav .product-thumbs__item')
        this.setupThumbs();

        this.addEventListener('carouselItemActivated', this.onItemActivated.bind(this));
        document.addEventListener('variantSelected', this.onVariantChange.bind(this));
        
        var featuredImg = this.querySelector('.product-image__slide[data-img-id="' + this.getAttribute('data-variant-image') + '"]');
        if (featuredImg) {
            this.activateItem(featuredImg.getAttribute('data-item'));            
        }        
    }

    connectedCallback() {      
        this.reInit();
    }

    onItemActivated(evt) {        
        this.activateThumb(evt.detail.itemIndex);        
    }

    onVariantChange(evt) {        
        var featuredImg = this.querySelector('.product-image__slide[data-img-id="' + evt.detail.imgId + '"]');        
        if (featuredImg) {
            this.activateItem(featuredImg.getAttribute('data-item'));        
        }
    }    

    reInit() {        
        if (window.innerWidth < 750) {
            this.settings.columns = 1;
            this.defaultOffset = 30;
        } else {
            this.settings.columns = parseInt(this.getAttribute('columns')) || 4;
            this.defaultOffset = 0;
        }

        this.currentOffset = this.defaultOffset;
        this.itemWidth = this.wrapper.offsetWidth / this.settings.columns;

        if (window.innerWidth < 750) {
            this.itemWidth -= 40;
        }        
        
        if(this.querySelector('.carousel__item--active'))
            this.querySelector('.carousel__item--active').classList.remove('carousel__item--active');
        
        this.carouselTrack.style.width = this.itemWidth * this.carouselElements.length + 'px';
        this.carouselTrack.style.transform = 'translate3d(' + this.defaultOffset + 'px, 0px, 0px)';

        this.carouselElements.forEach((item, index) => {
            if (index == 0) {
                item.classList.add('carousel__item--active');
            }
            item.style.width = this.itemWidth + 'px';
        });        
    }

    setupThumbs() {
        this.thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener('click', this.thumbClick.bind(this));
        });
    }

    thumbClick(evt) {        
        var thumbIndex = evt.target.closest('.product-thumbs__item').getAttribute('data-thumb-index');
        this.activateItem(thumbIndex);
        this.activateThumb(thumbIndex);
    }

    activateThumb(thumbIndex) {        
        this.querySelector('.product-thumbs__item.thumb-current').classList.remove('thumb-current');
        this.querySelector('.product-thumbs__item[data-thumb-index="' + thumbIndex + '"]').classList.add('thumb-current');    
    }
}

customElements.define('product-images', ProductImagesComponent);

/*============================================================================
Slider
==============================================================================*/
class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.container = this.querySelector('.slider-section');
        this.slidesWrap = this.querySelector('.slider__inner');
        this.onActivateSlide = this.activateSlide.bind(this);        

        this.timeout = null;
        this.onTimeout = this.onNextBtnClick.bind(this);

        this.settings = {
            autoplay: this.getAttribute('autoplay') || false,
            autoplaySpeed: this.getAttribute('autoplaySpeed') || 5000
        };

        this.slides = this.querySelectorAll('.slider__item');
        
        this.currentSlide = 0;
        this.slidesLength = 0;                    
        this.bullets = this.querySelector('.slider__bullets');        
    }

    connectedCallback() {
        this.slides = this.querySelectorAll('.slider__item');
        
        this.currentSlide = 0;
        this.slidesLength = 0;
        this.slides.forEach(slide => { this.slidesLength++; });
            
        this.bullets = this.querySelector('.slider__bullets');
        if (this.slidesLength > 1) {
            this.init();
            this.bullets = this.querySelector('.slider__bullets');
        }    
    }
 
    init() {
        this.slidesWrap.style.width = this.slidesLength * 100 + "vw";
        this.slides.forEach((slide, index) => {
            slide.style.left = -index * 100 + "vw";
            slide.style.height = this.slidesWrap.offsetHeight + "px";            
        });
        this.createControls();
        this.autoplay();
    }

    autoplay() {
        if (!this.settings.autoplay)
            return;
        
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => { this.onTimeout(); }, this.settings.autoplaySpeed);
    }

    activateSlide(slideIndex) {
        this.autoplay();

        var newSlide = this.slidesWrap.querySelector('[data-slide="' + slideIndex + '"]');
        if (newSlide.classList.contains('slider__item--active'))
            return;
        
        this.slidesWrap.querySelector('.slider__item--active').classList.remove('slider__item--active');
        newSlide.classList.add('slider__item--active');

        this.bullets.querySelector('.slider__bullet--active').classList.remove('slider__bullet--active');
        this.bullets.querySelector('[data-bullet="' + slideIndex + '"]').classList.add('slider__bullet--active');

        this.currentSlide = parseInt(slideIndex);        
    }
    
    onPrevBtnClick() {
        const prevSlideIndex = parseInt(this.currentSlide) - 1;
        var slideToActivate = prevSlideIndex >= 0 ? prevSlideIndex : this.slidesLength - 1;

        this.activateSlide(slideToActivate);        
    }

    onNextBtnClick() {
        const nextSlideIndex = parseInt(this.currentSlide) + 1;
        var slideToActivate = nextSlideIndex < this.slidesLength ? nextSlideIndex : 0;
        
        this.activateSlide(slideToActivate);        
    }

    onBulletClick(e) {
        if (e.target.classList.contains('slider__bullet--active'))
            return;

        const newBulletIndex = parseInt(e.target.getAttribute('data-bullet'));        

        this.onActivateSlide(newBulletIndex);
    }    

    createControls() {
        var prevBtn = document.createElement('button'),
            nextBtn = document.createElement('button');
        
        prevBtn.role = "presentation";
        nextBtn.role = "presentation";
        
        prevBtn.classList.add('slider__prev-btn');
        nextBtn.classList.add('slider__next-btn');
        this.container.appendChild(prevBtn);
        this.container.appendChild(nextBtn);

        var bullets = document.createElement('ul');
        bullets.classList.add('slider__bullets');

        prevBtn.addEventListener('click', this.onPrevBtnClick.bind(this));
        nextBtn.addEventListener('click', this.onNextBtnClick.bind(this));

        this.slides.forEach((slide, index) => {
            var bullet = document.createElement('li'),
                bulletBtn = document.createElement('button');
            
            
            bullet.role = "presentation";
                        
            bulletBtn.innerHTML = index;
            bulletBtn.setAttribute('data-bullet', index);
            if (index == 0) {
                bulletBtn.classList.add('slider__bullet--active');
            }
                
            bullet.appendChild(bulletBtn);
            bullets.appendChild(bullet);
            
            bulletBtn.addEventListener('click', this.onBulletClick.bind(this));
        });

        this.container.appendChild(bullets);        
    }    
}

customElements.define('slider-section', SliderComponent);


/*============================================================================
  Video Component
==============================================================================*/
class VideoComponent extends HTMLElement {
    constructor() {
        super();

        this.container = this.querySelector('.video__iframe');
        
        this.key = this.container.id;
        this.videoId = this.container.getAttribute('data-id');
        this.onVideoReady = this.videoReady.bind(this);
        this.onVideoPlayerChange = this.videoPlayerChange.bind(this);

        document.addEventListener('ytIframeApiLoaded', this.loadVideo.bind(this));
    }

    connectedCallback() {
        this.init();
    }

    init() {        
        if (!universe.yt_iframe_api_ready) {             
            var script = document.createElement('script');
            script.onload = function () {                
                universe.yt_iframe_api_ready = 1;                

                window.YT.ready(function () {
                    var event = new CustomEvent('ytIframeApiLoaded');
                    document.dispatchEvent(event);
                });
            };
            script.src = 'https://www.youtube.com/iframe_api';

            document.head.appendChild(script); 
        } else {
            this.loadVideo();
        }
    }    

    videoPlayerChange(evt) {
        
    }

    loadVideo(e) {
        var args = {
            ratio: 16 / 9,
            videoId: this.videoId,
            playerVars: {
                iv_load_policy: 3,
                modestbranding: 1,
                rel: 0
            },
            events: {
                onReady: this.onVideoReady,
                onStateChange: this.onVideoPlayerChange
            }
        };

        var videoPlayer = new YT.Player(this.key, args);
        
        this.setVideoHeight();
        window.addEventListener('resize', this.setVideoHeight.bind(this));                    
    }

    videoReady(evt) {        
        var videoIframe = this.querySelector('#' + evt.target.h.id);                
        var videoCover = this.querySelector('.video__cover');
        evt.target.setPlaybackQuality('hd1080');
    
        this.querySelector('.video__play-button').addEventListener('click', function () {
            videoCover.style.display = 'none';
            videoIframe.classList.add('youtube-video_started');
            evt.target.playVideo();
        });  

    }    

    setVideoHeight() {
        var videoHeight = this.querySelector('.video__iframe').width * 9 / 16;
        this.querySelector('.video__iframe').style.height = videoHeight;
    }
}

customElements.define('youtube-video', VideoComponent);


class BgVideoComponent extends HTMLElement {
    constructor() {
        super();

        this.container = this.querySelector('.background__video');
        this.key = this.container.id;
        this.videoId = this.container.getAttribute('data-id');

        this.onBgVideoReady = this.videoReady.bind(this);
        this.onPlayerChange = this.playerChange.bind(this);

        this.isBgVideo = true;
        this.player = null;

        document.addEventListener('ytIframeApiLoaded', this.loadVideo.bind(this));
    }

    connectedCallback() {
        this.init();        
    }
    
    init() {        
        if (!universe.yt_iframe_api_ready) {             
            var script = document.createElement('script');
            script.onload = function () {                
                universe.yt_iframe_api_ready = 1;                

                window.YT.ready(function () {
                    var event = new CustomEvent('ytIframeApiLoaded');
                    document.dispatchEvent(event);
                });
            };
            script.src = 'https://www.youtube.com/iframe_api';

            document.head.appendChild(script); 
        } else {
            this.loadVideo();
        }
    }

    loadVideo(e) {                
        var args = {
            ratio: 16 / 9,
            videoId: this.videoId,
            playerVars: {
            playsinline: 1,
            cc_load_policy: 0,
            iv_load_policy: 3,
            modestbranding: 0,
            controls: 0,
            showinfo: 0,
            fs: 0,
            wmode: 'opaque',
            branding: 0,
            autoplay: 1,
            autohide: 0,
            quality: 'hd720',
            rel: 0
            },
            events: {
            'onReady': this.onBgVideoReady,
            'onStateChange': this.onPlayerChange
            }
        };

        this.player = new YT.Player(this.key, args);
        
        this.setVideoHeight();
        window.addEventListener('resize', this.setVideoHeight.bind(this));                    
    }

    videoReady(evt) {
        var videoData = this.querySelector('#' + evt.target.h.id);
        videoData.setAttribute('tabindex', '-1');
        evt.target.mute();
        evt.target.playVideo();
    }

    playerChange(evt) {      
        var player = YT.get(this.key);      
        if (evt.data == 0 && player != 'undefined') {            
            player.seekTo(0);
        }
    }

    setVideoHeight() {    
        var videoContainer = this.querySelector('.background__video[id="'+this.key+'"]');
        var videoHeight = window.innerWidth * 9 / 16;

        var videoWrap = this.parentNode;

        if (videoWrap.height < videoHeight) {
            videoContainer.style.width = '100%';
            videoContainer.style.height = videoHeight;
        } else {
            videoContainer.style.width = videoWrap.height * 16 / 9 ;
            videoContainer.style.height = '200%';
        }
  }
}

customElements.define('background-video', BgVideoComponent);


// Collection Filters
document.querySelectorAll('[data-toggle="collection-sidebar-content"]').forEach((el) => {
    el.addEventListener('click', (evt) => {
        var filtersWrap = document.querySelector('#collection-sidebar-content');
        if (!!filtersWrap) {
            if (filtersWrap.classList.contains('is-open')) {
                filtersWrap.classList.remove('is-open');
            } else {
                filtersWrap.classList.add('is-open');
            }
        }
    });
});
